export var AuthType;
(function (AuthType) {
    /* sign in using a private key derived from your secret recovery phrase (SRP).
         Uses message signing snap to perform this operation */
    AuthType["SRP"] = "SRP";
    /* sign in with Ethereum */
    AuthType["SiWE"] = "SiWE";
})(AuthType || (AuthType = {}));
//# sourceMappingURL=types.mjs.map